import { useState, useEffect } from 'react';
import { useIsSsrMobile } from './isSsrMobile';

const MOBILE_BREAKPOINT = 1023;

export function useIsMobile(breakPoint = MOBILE_BREAKPOINT) {
  const isSsrMobile = useIsSsrMobile();
  const [isMobile, setIsMobile] = useState(isSsrMobile);

  const resizeHandler = () => {
    setIsMobile(window.innerWidth <= breakPoint);
  };

  useEffect(() => {
    resizeHandler();
    window.addEventListener('resize', resizeHandler);
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, []);

  const isSsr = typeof window === 'undefined';

  if (isSsr) {
    return isSsrMobile;
  }

  return isMobile;
}

export default useIsMobile;
